import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  FormControl,
  DialogContentText,
  DialogTitle,
  CircularProgress,
} from "@material-ui/core/";
import CloseButton from "../../../../buttonClose/.mixins/buttonClose";

import MultiSelectRadio from "../childrens/multiSelectRadio/.mixins/multiSelectRadio";
import MultiSelectCheckbox from "../childrens/multiSelectCheckbox/.mixins/multiSelectCheckbox";

export default function modalRadioButton(props) {
  const {
    checkedId,
    isModalOpen,
    headerModal,
    btComponent,
    buttonType,
    itensModal,
    setIdOnChange,
    getIdOnClick,
    handleDialogModal,
    SecondaryDescription,
    isLoading,
  } = props;

  const [scroll, setScroll] = useState("paper");
  const [enable, setEnable] = useState(false);
  const loading = isLoading ? isLoading : false;

  const handleChange = (event) => {
    setEnable(true)
    setIdOnChange(event.target.value);
  }

  const handleClick = () => {
    getIdOnClick()
    setEnable(false)
  }

  function HeaderModal() {
    return (
      <div>
        <CloseButton closeMethod={handleDialogModal} />
        <Typography style={{ marginLeft: "20px" }} variant="h6" align="center">
          {headerModal.title}
        </Typography>
        {headerModal.subtitle && (
          <Typography variant="subtitle2" align="center">
            {headerModal.subtitle}
          </Typography>
        )}
      </div>
    );
  }

  function BodyModal() {
    return (
      <>
        {loading && (
          <div align={"center"} width="100%">
            <CircularProgress />
          </div>
        )}
        {!loading && (
          <form
            id={"formSection"}
            noValidate
            autoComplete="off"
            encType="multipart/form-data"
          >
            <FormControl component="fieldset">
              {buttonType === "radio" ? (
                <MultiSelectRadio
                  idRadioChecked={checkedId}
                  itensModal={itensModal}
                  handleChange={handleChange}
                  SecondaryDescription={SecondaryDescription}
                />
              ) : (
                <MultiSelectCheckbox
                  itensModal={itensModal}
                  handleChange={handleChange}
                  SecondaryDescription={SecondaryDescription}
                />
              )}
            </FormControl>
          </form>
        )}
      </>
    );
  }

  function ButtonConfirm() {
    return (
      <>
        {btComponent != null && (
          <Typography style={{ padding: "10px" }} align="center">
            <Button variant="contained" onClick={handleClick} color="primary" disabled={enable ? null : "disabled"}>
              {btComponent.label}
            </Button>
          </Typography>
        )}
      </>
    );
  }

  return (
    <div>
      <Dialog
        open={isModalOpen}
        scroll={scroll}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth={"sm"}
      >
        <DialogTitle>
          <HeaderModal />
        </DialogTitle>
        <DialogContent dividers={scroll === "paper"}>
          <DialogContentText id="scroll-dialog-description">
            <BodyModal />
          </DialogContentText>
        </DialogContent>
        <ButtonConfirm />
      </Dialog>
    </div>
  );
}
